import { render, staticRenderFns } from "./AnalogMoneyLimit.vue?vue&type=template&id=35b613bc&"
import script from "./AnalogMoneyLimit.vue?vue&type=script&lang=ts&"
export * from "./AnalogMoneyLimit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports